export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};


type Rules = {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  isEmail?: boolean;
  isNumeric?: boolean;
};

const validationRules = {
  required: (value: string) => (value.trim() !== "" ? null : { required: true }),
  minLength: (value: string, rule: number) => value.length >= rule ? null : { minLength: true },
  maxLength: (value: string, rule: number) => value.length <= rule ? null : { maxLength: true },
  isEmail: (value: string) => {
    const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return pattern.test(value) ? null : { email: true };
  },
  isNumeric: (value: string) => {
    const pattern = /^\d+$/;
    return pattern.test(value) ? null : { numeric: true };
  },
};

export const checkValidity = (value: string, rules: Rules) => {
  for (const [key, ruleValue] of Object.entries(rules)) {
    const validate = validationRules[key as keyof typeof validationRules];
    if (validate) {
      const result = validate(value, ruleValue as number); // Burada ruleValue'nun türü kesinleşti
      if (result) {
        return { isValid: false, ...result };
      }
    }
  }
  return { isValid: true };
};

// isim_BugününTarihveSaati
export const dateNow = (name: string): string => {
  const currentDate = new Date();
  const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}${String(currentDate.getMonth() + 1).padStart(2, '0')}${currentDate.getFullYear()}_${String(currentDate.getHours()).padStart(2, '0')}${String(currentDate.getMinutes()).padStart(2, '0')}${String(currentDate.getSeconds()).padStart(2, '0')}`; // DDMMYYYY_HHMMSS formatında tarih ve saat
  const fileName = `${name}_${formattedDate}`;
  return fileName;
};

// ExportExcel İçin Column Generator
export const columnMappings = (columns: any): { [key: string]: string } => {
  let formattedData: { [key: string]: string } = {};
  columns.forEach((column: any) => {
    if (column.hasOwnProperty('dataIndex') && column.hasOwnProperty('title')) {
      formattedData[column.dataIndex] = column.title;
    }
  });
  return formattedData;
};